import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { filter, map, Observable, startWith, switchMap, tap } from 'rxjs';
import { Vehicle } from 'src/app/data/model/vehicle';
import { BaseComponent } from 'src/app/shared/base/base-component.directive';
import { VehicleMapMarkersService } from '../../services/vehicle-map-markers.service';
import * as L from 'leaflet';


const Validate: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {

  if( control.get('start')?.value && control.get('end')?.value){
    const start_date = new Date(control.get('start')?.value);
    const end_date = new Date(control.get('end')?.value);

    if(start_date > end_date){
      return  { 'date_err': true };
    }

    const diff= end_date.getTime() - start_date.getTime()
    if ((diff/(1000*60*60)) > 120) {
      return { 'date-diff': true };
    }
    
  }
  
  return null;
};

@Component({
  standalone: false,
  selector: 'app-vehicle-map-filter-dialog',
  templateUrl: './vehicle-map-filter-dialog.component.html',
  styleUrls: ['./vehicle-map-filter-dialog.component.scss'],
  //providers: [VehicleMapMarkersService]
})
export class VehicleMapFilterDialogComponent extends BaseComponent implements OnInit {

  vehicle!: Vehicle;
  layer!: L.FeatureGroup;

  filterFormGroup: FormGroup = this.formBuilder.group({
    start: [null, [Validators.required]],
    end: [null, [Validators.required]]
  }, { validator: Validate });


  options:any=this.data;

  get selectedField(): FilterField {
    return this.filterFormGroup.value?.field;
  }

  get FieldType(): typeof FieldType {
    return FieldType;
  }
  
  constructor(
    @Inject(MAT_DIALOG_DATA) public data:VehicleDialogData,
    private dialogRef: MatDialogRef<VehicleMapFilterDialogComponent>,
    private formBuilder: FormBuilder,
    private service: VehicleMapMarkersService, 
  ) {
    super();
  }

  ngOnInit() {
    this.filterFormGroup.reset({
      start: null,
      end: null
    });
  }
  
  group= new L.FeatureGroup();
  addFilter() {
    var vehicle:Vehicle[];
    //MapDialogComponent.layer.clearLayers();
    this.filterFormGroup.markAllAsTouched();
    if (this.filterFormGroup.valid) {
      const search_value= this.data.vehicle.data_collector;//licenseplate;
      const start_date = this.filterFormGroup.value.start;
      const end_date = this.filterFormGroup.value.end;
      this.service.filterVehiclePoints(this.data.layer, search_value, start_date, end_date);
      //MapDialogComponent.data=vehicle[0];
      this.dialogRef.close();
    };
    //this.group.addTo(MapDialogComponent.layer);
  }

  setVehicleData(data:Vehicle){
    var vehicle_data:Vehicle=data;  
    return vehicle_data
  }
}


export type GridFilterParam = {
  fields: FilterField[];
};

export type FilterField = {
  name: string;
  text: string;
  type: FieldType;
  options?: Observable<FilterFieldOption[]>;
};


export enum FieldType {
  TEXT,
  AUTOCOMPLETE,
  DATETIME
}

export type FilterFieldOption = { licenseplate: string; plate: string };

interface VehicleDialogData {
  vehicle: Vehicle;
  layer: L.FeatureGroup;
}